
// @vendors
const React = require('react');

const PropTypes = require('prop-types');
const comlexity_icon = require('assets/icons/complexity_icon.svg');
const candado_icon = require('assets/icons/icon-candado.svg')


// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { OKLink } = require('commonsComponents/OKLink');
const RiskNumbers = require('./riskNumbers');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

require('./brokerRiskIndicator.scss');

const RiskIndicator = ({ riskValue, textContent, links, hasAlert, typeAlert, productType }) => {
    const linksOfComponent = links.length && links.map((link) => {
        const linkName = link.replace(/(^\w+:|^)\/\//, '');
        return (<OKLink key={link} to={link} target="_blank">{linkName}</OKLink>);
    });

    const buildLiquidityAlert = (description) => {
        return (
            <div className="broker-risk-information-box-type-seven__alert">
                <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                <div className="broker-risk-information-box-type-seven__warning-description">
                    {description}
                </div>
            </div>
        );
    }

    const buildComplexityAlerts = () => {
        return(
            <div className="broker-risk-indicator__alert-comlexity">
                <FormattedText value="fundsCard-alertComplexity_title" /><br/>
                <img src={comlexity_icon} alt="complexity icon" /> <FormattedText value="fundsCard-alertComplexity_content" />
            </div>
        )
    }

    const buildLiquidityAlerts = () => {
        return (
            <div>
                <div className="broker-risk-information-box-type-seven__text broker-risk-information-box-type-seven__title">
                    <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertTitle"/>
                </div>
                {buildLiquidityAlert(<FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertText1"/>)}
                {buildLiquidityAlert(<FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertText2"/>)}
            </div>

        );
    }

    const riskIndicator = (textContent, linksOfComponent, riskValue, productType) => {
        const minorRiskKey =`fundsCard-riskIndicator${productType}_minorRisk`;
        const majorRiskKey =`fundsCard-riskIndicator${productType}_majorRisk`;
        return (
            <div className="broker-risk-indicator-container">
                <div className="broker-risk-indicator-container__title">
                    <FormattedText value="fundsCard-riskIndicatorFunds_title" />
                </div>
                <div className="broker-risk-indicator-container__content">
                    <div className="broker-risk-indicator-risk-numbers">
                        <RiskNumbers riskValue={riskValue} />
                        <div className="broker-risk-indicator-risk-numbers__risk-text">
                            <FormattedText value={minorRiskKey} />
                            <FormattedText value={majorRiskKey} />
                        </div>
                    </div>
                    <div className="broker-risk-indicator-risk-content">
                        <FormattedTextWithComponents value={textContent} injectedComponents={linksOfComponent} />
                    </div>
                </div>
            </div>
        )
    };

    const riskIndicatorLiquidity = (textContent, linksOfComponent, riskValue, typeAlert, productType) => {
        const minorRiskKey =`fundsCard-riskIndicator${productType}_minorRisk`;
        const majorRiskKey =`fundsCard-riskIndicator${productType}_majorRisk`;
        return (
            <div className="broker-risk-indicator-liquidity">
                <div className="broker-risk-indicator-liquidity__container">
                    <div className="broker-risk-indicator-container__title">
                        <FormattedText value="fundsCard-riskIndicatorFunds_title" />
                    </div>
                    <div className="broker-risk-indicator-container__content-liquidity">
                        <div className="broker-risk-indicator-risk-numbers">
                            <RiskNumbers riskValue={riskValue} liquidity={true} />
                            <div className="broker-risk-indicator-risk-numbers__risk-text">
                                <FormattedText value={minorRiskKey} />
                                <FormattedText value={majorRiskKey} />
                            </div>
                        </div>
                        <div className="broker-risk-indicator-risk-content__liquidity">
                            <FormattedTextWithComponents value={textContent} injectedComponents={linksOfComponent} />
                        </div>
                    </div>
                </div>
                { typeAlert === 'liquidity' ? buildLiquidityAlerts() : buildComplexityAlerts()}
            </div>
        )
    };

    return (
        <div>
            {
                hasAlert ?
                    riskIndicatorLiquidity(textContent, linksOfComponent, riskValue, typeAlert, productType)
                    : riskIndicator(textContent, linksOfComponent, riskValue, productType)
            }
        </div>
    );
};

RiskIndicator.propTypes = {
    riskValue: PropTypes.number,
    textContent: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.string),
    hasAlert: Boolean,
    typeAlert: PropTypes.string,
    productType: PropTypes.string
};

RiskIndicator.defaultProps = {
    links: [],
    riskValue: 0,
    content: '',
    hasAlert: false,
    typeAlert: '',
    productType: 'Funds'
};

module.exports = RiskIndicator;